import DOMPurify from 'dompurify';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// ─── HTML / Rich-Text Utilities ──────────────────────────────────────────────

export function extractPlainText(html: string): string {
  return DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });
}

export function getPlainTextLength(html: string): number {
  return extractPlainText(html).trim().length;
}

export function hasRichTextContent(html: string): boolean {
  return getPlainTextLength(html) > 0;
}

export function ensurePlainText(input?: string): string {
  if (!input) return '';
  return extractPlainText(input);
}

export function sanitizeRichHtml(html: string): string {
  return DOMPurify.sanitize(html || '', { USE_PROFILES: { html: true } });
}

export function sanitizeTrustedHtml(sanitizer: DomSanitizer, html: string): SafeHtml {
  return sanitizer.bypassSecurityTrustHtml(sanitizeRichHtml(html));
}
